import "./Login.scss";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { URLS } from "./helpers/URLS";
import useAxios from "./helpers/Hooks/useAxios";
import NabBar from "./components/Navbar/NabBar";
import Footer from "./components/Footer/Footer";
import PasswordInput from "./components/PasswordInput/PasswordInput";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { callMsGraph } from "./graph";
import ArtLogin from "./assets/images/art-login.svg"
import ArtForgot from "./assets/images/art-forgot.svg"
import ArtOtp from "./assets/images/art-otp.svg"
import ArtReset from "./assets/images/art-reset.svg"

const Login = () => {

  const navigate = useNavigate();
  const { fetchData } = useAxios();
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  // Added states for forgot password flow
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleLogin = (e, loginType = "popup") => {
    e.preventDefault();
    // if (loginType === "popup") {
    //     instance.loginPopup(loginRequest).catch(e => {
    //         console.log(e);
    //     });
    // } else if (loginType === "redirect") {
    //     instance.loginRedirect(loginRequest).catch(e => {
    //         console.log(e);
    //     });
    // }
  }


  const [loginPayload, setLoginPayload] = useState({
    //email: "bhargavi.palli@motivitylabs.com",
    email: "",
    password: "",
  });

  useEffect(() => {
    checkIsAuthenticated();
  }, []);

  const checkIsAuthenticated = async () => {
    const resp = await fetchData({ url: URLS.auth, method: "get" });
    if (resp.status === 200) {
      navigate("/dashBoard");
    }
  }

  const handleChange = (e) => {
    setLoginPayload({
      ...loginPayload,
      [e.target.name]: e.target.value,
    });
  };

  const submitLogin = async (e) => {
    if (!e) {
      return null;
    }
    e.preventDefault();
    const resp = await fetchData({
      url: URLS.login,
      method: "post",
      body: loginPayload,
    });
    if (resp && resp.status === 200) {
      navigate("/dashBoard");
      toast.success(resp.message)
    }
    else {
      toast.error((resp && resp.message) || "Could not sign you in. Please try again.")
    }
  }

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setForgotPasswordMode(true);
  }

  const goBackToLogin = (e) => {
    e.preventDefault();
    setForgotPasswordMode(false);
    setOtpSent(false);
    setOtpVerified(false);
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");
  }

  const sendOtp = async (e) => {
    e.preventDefault();
    if (!loginPayload.email.trim()) {
      toast.error("Please enter your email");
      return;
    }

    
    try {
      const resp = await fetchData({
        url: URLS.forgetPassword,
        method: "post",
        body: { email: loginPayload.email },
      });
      
      if (resp.status === 200) {
        setOtpSent(true);
        toast.success(resp?.message || 'Otp sent to Email');
      } else {
        toast.error(resp.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error("Error sending OTP");
    }

 
    
    // toast.success("OTP sent successfully to your email");
    // setOtpSent(true);
  }

  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!otp.trim()) {
      toast.error("Please enter OTP");
      return;
    }

 

    try {
      const resp = await fetchData({
        url: URLS.verifyOtp,
        method: "post",
        body: { email: loginPayload.email, otp },
      });

      if (resp.status === 200) {
        setOtpVerified(true);
        toast.success(resp?.message|| "Otp Verified");
      } else {
        toast.error(resp.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error("Error verifying OTP");
    }
  }

  const resetPassword = async (e) => {
    e.preventDefault();

    if (!newPassword.trim() || !confirmPassword.trim()) {
      toast.error("Please fill all fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    // For testing purposes
   // toast.success("Password reset successfully");
    // setForgotPasswordMode(false);
    // setOtpSent(false);
    // setOtpVerified(false);
    // setOtp("");
    // setNewPassword("");
    // setConfirmPassword("");

    try {
      const resp = await fetchData({
        url: URLS.changePassword, 
        method: "put",
        body: {
          email: loginPayload.email,
          otp,
          password:newPassword,
          confirmPassword:confirmPassword
        },
      });

      if (resp.status === 200) {
        toast.success(resp?.message ||"Password reset successfully");
        setForgotPasswordMode(false);
        setOtpSent(false);
        setOtpVerified(false);
        setOtp("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(resp.message || "Failed to reset password");
      }
    } catch (error) {
      toast.error("Error resetting password");
    }
  }

  const currentStep = () => {
    if (!forgotPasswordMode) {
      return {
        art: ArtLogin,
        heading: "Work Report Portal",
        blurb: "Track your day, share your progress, stay in sync with the team.",
      };
    }
    if (otpVerified) {
      return {
        art: ArtReset,
        heading: "Pick a strong one",
        blurb: "Your new password takes effect the moment you save it.",
      };
    }
    if (otpSent) {
      return {
        art: ArtOtp,
        heading: "Check your inbox",
        blurb: "The six-digit code is valid for a short while, so use it soon.",
      };
    }
    return {
      art: ArtForgot,
      heading: "Locked out?",
      blurb: "Give us the email on your account and we'll send a code to reset it.",
    };
  };

  const renderFormContent = () => {
    if (forgotPasswordMode) {
      if (otpVerified) {
        return (
          <>
            <div className="form-head">
              <h2 className="title">Reset Password</h2>
              <p className="subtitle">Choose a new password for your account</p>
            </div>
            <PasswordInput
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter New Password"
              autoComplete="new-password"
            />
            <PasswordInput
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm New Password"
              autoComplete="new-password"
            />
            <button type="button" onClick={resetPassword} className="button_login">Reset Password</button>
            <button type="button" onClick={goBackToLogin} className="button_back">Back to Login</button>
          </>
        );
      } else if (otpSent) {
        return (
          <>
            <div className="form-head">
              <h2 className="title">Verify OTP</h2>
              <p className="subtitle">Enter the code we sent to your email</p>
            </div>
            <input
              type="text"
              value={loginPayload.email}
              onChange={handleChange}
              name="email"
              placeholder="email@motivitylabs.com"
              disabled
            />
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={verifyOtp} className="button_login">Verify OTP</button>
            <button type="button" onClick={goBackToLogin} className="button_back">Back to Login</button>
          </>
        );
      } else {
        return (
          <>
            <div className="form-head">
              <h2 className="title">Forgot Password</h2>
              <p className="subtitle">We'll email you a one-time code to reset it</p>
            </div>
            <input
              type="text"
              value={loginPayload.email}
              onChange={handleChange}
              name="email"
              placeholder="email@motivitylabs.com"
            />
            <button type="button" onClick={sendOtp} className="button_login">Send OTP</button>
            <button type="button" onClick={goBackToLogin} className="button_back">Back to Login</button>
          </>
        );
      }
    } else {
      return (
        <>
          <div className="form-head">
            <h2 className="title">Member Login</h2>
            <p className="subtitle">Sign in to continue to your dashboard</p>
          </div>
          <input
            type="text"
            value={loginPayload.email}
            onChange={handleChange}
            name="email"
            placeholder="email@motivitylabs.com"
          />
          <PasswordInput
            name="password"
            value={loginPayload.password}
            onChange={handleChange}
            placeholder="Enter Password"
            autoComplete="current-password"
          />
          <button type="submit" className="button_login">Login</button>
          <p className="forgot-row">
            <a href="#" onClick={handleForgotPassword} className="forgot-credentials">Forgot Password?</a>
          </p>
          <p className="or_text">or</p>
          <button type="button" onClick={(e) => handleLogin(e, "popup")} className="microsoft_button">
            <svg className="img_mic" viewBox="0 0 23 23" aria-hidden="true" focusable="false">
              <rect x="1" y="1" width="10" height="10" fill="#f25022" />
              <rect x="12" y="1" width="10" height="10" fill="#7fba00" />
              <rect x="1" y="12" width="10" height="10" fill="#00a4ef" />
              <rect x="12" y="12" width="10" height="10" fill="#ffb900" />
            </svg>
            Sign in with Microsoft
          </button>
          <p className="activate-row">
            New here? <a className="activate-link" onClick={(e) => { navigate("/AccountActivate") }}>Activate Account</a>
          </p>
        </>
      );
    }
  };

  const step = currentStep();

  return (
    <div>
      <NabBar />
      <form onSubmit={!forgotPasswordMode ? submitLogin : (e) => e.preventDefault()}>
        <div id="login">
          <div className="login-card">
            <div className="profile">
              <div className="profile-art">
                <img src={step.art} className="profile-image" alt="" />
              </div>
              <div className="brand-copy">
                <h3 className="brand-heading">{step.heading}</h3>
                <p className="brand-sub">{step.blurb}</p>
              </div>
            </div>
            <div className="login-details">
              {renderFormContent()}
            </div>
          </div>
        </div>
      </form>

      <Footer />
    </div>
  );
};

export default Login;